<script lang="ts">
  // this page is the same as all the others, but it opens introduction.md
  import Page from './[page]/+page.svelte'

  const { data } = $props()
</script>

<Page {data} />
